import { render, staticRenderFns } from "./GovernmentClaimSource.vue?vue&type=template&id=02a10edd&"
import script from "./GovernmentClaimSource.vue?vue&type=script&lang=js&"
export * from "./GovernmentClaimSource.vue?vue&type=script&lang=js&"
import style0 from "./GovernmentClaimSource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports